import React from 'react';
import { Row, Col, Button, Alert, Modal } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';
import PackingItemListContainer from '../containers/PackingItemListContainer.jsx';
import PackingBoxNumberEditContainer from '../containers/PackingBoxNumberEditContainer.jsx';

export default class PackingBySystemComponent extends React.Component {

  componentDidMount() {
    this.props.findAllFirefighterTypes();
  }

  componentWillUnmount() {
    this.props.clearPackingAlert();
  }

  render() {
    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.clearPackingAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          {alertDiv}
        </Row>
        <hr />
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={12} sm={2} md={2}>
            <DropDownInput id="firefighterType"
              label="警義消別"
              required="true"
              options={this.props.allFirefighterTypes.map((value, key) => ({ label: value.get('display_name'), value: value.get('firefighter_type') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setPackingBySystemBeanValue(id, value);
              }}
              validation={this.props.packingBySystemValidation.get('firefighterType')}
            />
          </Col>
          <Col xs={12} sm={3} md={3}>
            <DropDownInput id="category"
              label="群組"
              required="true"
              options={this.props.distinctCategories.map((value, key) => ({ label: value, value: value })).toJS()}
              onChange={(id, value, label) => {
                this.props.setPackingBySystemBeanValue(id, value);
              }}
              validation={this.props.packingBySystemValidation.get('category')}
            />
          </Col>
          <Col xs={12} sm={3} md={3}>
            <DropDownInput id="packingType"
              label="裝箱方式"
              required="true"
              options={this.props.packTypes}
              onChange={(id, value, label) => {
                this.props.setPackingBySystemBeanValue(id, value);
              }}
              validation={this.props.packingBySystemValidation.get('packingType')}
            />
          </Col>
          <Col xs={12} sm={4} md={4}>
            <div style={{ paddingTop: 25 }}>
              <Button onClick={this.props.packingItems} bsStyle="info">
                裝箱
					    </Button>
            </div>
          </Col>
        </Row>
        <hr />
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={12} sm={2} md={2}>
            <DropDownInput id="boxNumber"
              label="箱號"
              required="true"
              options={this.props.boxNumbers.map((value, key) => ({ label: value.get('label'), value: value.get('value') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setShippingLabelValue(id, value);
                this.props.findShippingLabel({ orderId: this.props.orderId, boxNumber: value });
                this.props.findPackingItemList({ orderId: this.props.orderId, boxNumber: value });
              }}
              validation={this.props.shippingLabelValidation.get('boxNumber')}
            />
          </Col>
          <Col xs={12} sm={3} md={3}>
            <FieldGroup
              id="boxLabel"
              type="text"
              label="BOX LABEL"
              value={this.props.shippingLabel.get('boxLabel')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setShippingLabelValue(id, value);
              }}
              validation={this.props.shippingLabelValidation.get('boxLabel')}
            />
          </Col>
          <Col xs={12} sm={7} md={7}>
            <div style={{ paddingTop: 25 }}>
              <Button onClick={this.props.editShippingBoxLabel} bsStyle="info" style={{ marginRight: 5 }}>
                更新 box label
					    </Button>
              <Button onClick={this.props.clearPackingItems} bsStyle="default" style={{ marginRight: 5 }}>
                <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
                <span style={{ color: '#a94442' }}>刪除單一箱號</span>
              </Button>
              <Button onClick={this.props.clearAllPackingItems} bsStyle="default">
                <span className="glyphicon glyphicon-trash" style={{ marginRight: 10, color: '#a94442' }} />
                <span style={{ color: '#a94442' }}>刪除全部箱號</span>
              </Button>
            </div>
          </Col>
        </Row>
        <hr />
        <PackingItemListContainer orderId={this.props.orderId} boxNumber={this.props.shippingLabel.get('boxNumber')} />
        <Modal show={this.props.showPackingBoxNumberModal} onHide={this.props.closeModal} backdrop="static">
          <Modal.Header closeButton />
          <Modal.Body>
            <PackingBoxNumberEditContainer />
          </Modal.Body>
        </Modal>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/PackingBySystemComponent.jsx